import script from './panel-month-range.vue_vue_type_script_lang.mjs';
export { default } from './panel-month-range.vue_vue_type_script_lang.mjs';
import { render } from './panel-month-range.vue_vue_type_template_id_2e377892_lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/panel-month-range.vue";
//# sourceMappingURL=panel-month-range.mjs.map
